import { ComponentType } from 'react';

import { RiFlagLine } from '@remixicon/react';

import { pathToModuleStyle } from '@spotify/confidence-core-react';
import {
  createArtifactExtension,
  isExternalLink,
} from '@spotify/plugin-confidence-projects-react';

import { projectsPlugin } from '../plugin';
import { ResourcePreview } from './previews/ResourcePreview';
import {
  RuleArtifactCard,
  RuleArtifactListItem,
  SegmentArtifactCard,
  SegmentArtifactListItem,
  WorkflowArtifactCard,
  WorkflowArtifactListItem,
} from './resolvers';
import { isRuleUri, isSegmentUri, isWorkflowInstanceUri } from './resourceUri';

type ArtifactIconComponent = ComponentType<{
  size?: number | string;
  className?: string;
  style?: object;
}>;

export const ResourceArtifactExtension = projectsPlugin.provide(
  createArtifactExtension({
    id: 'resource',
    predicate: artifact => !isExternalLink(artifact.uri),
    icon: artifact => {
      const style = pathToModuleStyle(artifact.uri);
      if (style) {
        return {
          Icon: style.Icon as ArtifactIconComponent,
          color: style.color,
        };
      }
      return { Icon: RiFlagLine, color: '#E74C3C' };
    },
    label: 'Resource',
    category: 'Resources',
    render: artifact => <ResourcePreview artifact={artifact} />,
    renderListItem: (artifact, { onSelect, onDelete }) => {
      if (isWorkflowInstanceUri(artifact.uri)) {
        return (
          <WorkflowArtifactListItem
            artifact={artifact}
            onSelect={onSelect}
            onDelete={onDelete}
          />
        );
      }
      if (isSegmentUri(artifact.uri)) {
        return (
          <SegmentArtifactListItem
            artifact={artifact}
            onSelect={onSelect}
            onDelete={onDelete}
          />
        );
      }
      if (isRuleUri(artifact.uri)) {
        return (
          <RuleArtifactListItem
            artifact={artifact}
            onSelect={onSelect}
            onDelete={onDelete}
          />
        );
      }
      return undefined;
    },
    renderCard: (artifact, onClick) => {
      if (isWorkflowInstanceUri(artifact.uri)) {
        return <WorkflowArtifactCard artifact={artifact} onClick={onClick} />;
      }
      if (isSegmentUri(artifact.uri)) {
        return <SegmentArtifactCard artifact={artifact} onClick={onClick} />;
      }
      if (isRuleUri(artifact.uri)) {
        return <RuleArtifactCard artifact={artifact} onClick={onClick} />;
      }
      return undefined;
    },
  }),
);
